/**
 * Une échelle d'évaluation ne mesure pas un indicateur mais une opinion, et n'a donc pas de mauvais
 * côté : tous ses crans portent la même couleur, quel que soit leur nombre.
 */
export const RATING_COLOR = '#2f54eb';
